// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ty-2";
export var chatLink = "_ty-0";
export var chatText = "_ty-1";